module.exports = __webpack_public_path__ + "img/tatiana-webinar.69668a57.jpg";